import { useRef } from 'react';
import M_HeaderBox from './mHeader';
import M_FooterBox from './mFooter';

export default function FKS_M_Wrap({
  isLogin,
  children,
}: {
  isLogin: boolean
  children: React.ReactNode;
}) {
  return (
    <div className='w-full'>
      <M_HeaderBox isLogin={isLogin} />
      <main className='w-full'>{children}</main>
      <M_FooterBox />
    </div>
  );
}
